import { Link } from "react-router-dom";
import { NAV, SITE } from "@/siteData";

export const Footer = () => {
  return (
    <footer className="relative mt-24 overflow-hidden border-t border-line bg-ink text-paper grain" data-testid="site-footer">
      <div className="container-x relative py-16 sm:py-20">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <img
                src="/logo-mark.png"
                alt="Simple Background Remover app icon"
                className="h-10 w-10 rounded-xl ring-1 ring-white/10"
                width="40"
                height="40"
              />
              <span className="font-display text-lg font-bold tracking-tight">
                Simple Background Remover
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-white/60">
              Private, on-device batch background removal. Your photos never leave your phone.
            </p>
            <a
              href={`mailto:${SITE.email}`}
              className="link-underline mt-5 inline-block font-mono text-sm text-brand-bright"
              data-testid="footer-email"
            >
              {SITE.email}
            </a>
          </div>

          <nav className="grid grid-cols-2 gap-x-12 gap-y-3 sm:flex sm:flex-col" aria-label="Footer">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`footer-link-${item.to === "/" ? "home" : item.to.slice(1)}`}
                className="link-underline text-sm font-medium text-white/75 transition-colors hover:text-white"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-8 text-xs text-white/45 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© {SITE.year} {SITE.company}. All rights reserved.</p>
          <p className="font-mono uppercase tracking-[0.2em]">
            Effective Date — {SITE.effectiveDate}
          </p>
        </div>
      </div>
    </footer>
  );
};
